import { createContext, useContext, useEffect, useState } from "react";

const initialState = {
  privacyOn: false,
  setPrivacyOn: () => null,
  togglePrivacy: () => null,
};

const PrivacyProviderContext = createContext(initialState);

export function PrivacyProvider({ children, storageKey = "privacy-on" }) {
  const [privacyOn, setPrivacyOn] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(storageKey);
    if (stored !== null) {
      setPrivacyOn(stored === "true");
    }
  }, [storageKey]);

  useEffect(() => {
    localStorage.setItem(storageKey, privacyOn);
  }, [privacyOn, storageKey]);

  const togglePrivacy = () => {
    setPrivacyOn((prev) => !prev);
  };

  const value = {
    privacyOn,
    setPrivacyOn,
    togglePrivacy,
  };

  return (
    <PrivacyProviderContext.Provider value={value}>
      {children}
    </PrivacyProviderContext.Provider>
  );
}

export const usePrivacy = () => {
  const context = useContext(PrivacyProviderContext);
  if (!context) {
    throw new Error("usePrivacy must be used within a PrivacyProvider");
  }
  return context;
}; 